import React, { useState, useEffect } from 'react'
import ModalPreview from '../form/modalPreview';
import axios from 'axios';
import FormTip from '../../commons/form_tip';
import {getCsrfToken} from '../../commons/authenticityToken';

const Index = (props) => {
    axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

    // ユーザー区分
    const is_general_user = props.current_m_user_user_kbn === "reader" ? true : false 

    // テンプレート
    const [parts, setParts] = useState([]);

    // プレビュー用
    const [ previewPart, setPreviewPart　] = useState({id: 0, display_web_name: null, title: null});
    const [ previewPartFields, setPreviewPartFields ] = useState([]);


    // 削除対象テンプレート
    const [deletePart, setDeletePart] = useState({id: 0, name: ""});
    // 削除モーダルメッセージ
    const [isLinked, setIsLinked] = useState(false);
    // コピー対象テンプレート
    const [copyPart, setCopyPart] = useState({id: 0, name: ""});
    const [searchPartOwnerKbn, setSearchPartOwnerKbn]  = useState(["0", "1"]);

    // 検索内容
    const [searchName, setSearchName] = useState("");

    // メッセージエリア
    const [infoMessage, setInfoMessage] = useState("");
    
    // 初期ロード
    useEffect(() =>{
        axios.get(
        '/api/internal/parts/search_parts', { params: { name: searchName, share_range_kbn: searchPartOwnerKbn}})
        .then(function (response) {
            setParts(response.data.m_parts);
        })
        .catch(error => {
            alert(error.response.data.message)
        }
        ); 
    }, [])

    function searchParts(){
        axios.get(
            '/api/internal/parts/search_parts', { params: { name: searchName, share_range_kbn: searchPartOwnerKbn}})
            .then(function (response) {
                setParts(response.data.m_parts);
            })
            .catch(error => {
                alert(error.response.data.message)
            }
        ); 
    }

    function onClickDeleteButton(){
        setInfoMessage("");
        axios.delete(
            '/api/internal/parts/destroy', {
                data: { id: deletePart.id }
            })
            .then(function (response) {
                setParts(
                    parts.filter(function(part){
                        return part.id !== deletePart.id
                    })
                );
                setInfoMessage(response.data.message);
            })
            .catch(error => {
                alert(error.response.data.message)
            }
        );
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }
    // コピー処理
    function onClickCopyButton(){
        axios.post(
            '/api/internal/parts/copy', { id: copyPart.id }
        ).then(function (response) {
            setCopyPart({id: 0, name: ""});
            setParts([...parts, response.data.part]);
            setInfoMessage(response.data.message);
            }
        ).catch(error => {
            alert(error.response.data.message);
            setCopyPart({id: 0, name: ""});
        }); 
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }

    // チェックボックス更新
    function changePartOwner(target) {
        if (target.checked){
            setSearchPartOwnerKbn([...searchPartOwnerKbn, target.value]);
        }else{
            setSearchPartOwnerKbn(searchPartOwnerKbn.filter(value => value !== target.value));
        }
    }

    function showPreview(m_part_id){
        // 初期化
        setPreviewPartFields([]);
        setPreviewPart({id: 0, display_web_name: null, title: null});
        axios.get(
            '/api/internal/parts/preview?id=' + m_part_id, {})
            .then(function (response) {
                setPreviewPartFields(response.data.m_part_fields);
                setPreviewPart(response.data.m_part);
                document.getElementById("open_preview_modal").click();
            })
            .catch(error => {
                //setErrorMessage(error.response.data.message);
            });
    }

    function checkLinked(part){
        setIsLinked(false);
        setDeletePart({id: 0, name: ""});
        axios.get(
            '/api/internal/parts/linked_part_groups', { params: { id: part.id }}
            ).then(function (response) {
                setDeletePart(part)
                response.data.m_part_groups.length != 0 && setIsLinked(true);
                document.getElementById("open_delete_modal").click();
            })
            .catch(error => {
                alert(error.response.data.message)
            }
            );
    }

    return(
        <>
            { infoMessage &&
                <div className="alert fade in alert-success ">
                    <button type="button" className="close" data-dismiss="alert">×</button>
                    {infoMessage}
                </div>
            }
            <h3>先確認質問一覧</h3>
            {/* 検索エリア */}
            <div id="patient_search_area" className="panel panel-success">
                <div className="panel-heading">検索エリア</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="form-group col-md-7 col-xs-12">
                            <label >質問名</label>
                            <input 
                                type="text"
                                name="search_name" 
                                id="search_name" 
                                className="form-control col-lg-1" 
                                placeholder="検索したい内容を入力してください"
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6 col-xs-12">
                            <FormTip description="自社質問：自社で作成した質問¥n共通質問：デフォルトで作成されている質問(編集不可)">
                                <label>質問所有者</label>
                            </FormTip>
                            <div className="col-md-4 col-xs-4">
                                <input 
                                    type="checkbox" 
                                    name="search_template_owner_kbn"
                                    id="search_template_owner_kbn_0"
                                    value={0}
                                    defaultChecked={searchPartOwnerKbn.includes("0")}
                                    onChange={(e) => changePartOwner(e.target)}
                                />
                                <label htmlFor="search_template_owner_kbn_0">自社質問</label>
                            </div>

                            <div className="col-md-4 col-xs-4">
                                <input 
                                    type="checkbox" 
                                    name="search_template_owner_kbn"
                                    id="search_template_owner_kbn_1"
                                    value={1}
                                    defaultChecked={searchPartOwnerKbn.includes("1")}
                                    onChange={(e) => changePartOwner(e.target)}
                                />
                                <label htmlFor="search_template_owner_kbn_1">共通質問</label>
                            </div>
                        </div>
                        <div className="form-group col-md-6 col-xs-12 mt10 text-right">
                            <input type="submit" name="button_search" value="検索" className="btn btn-lg btn-primary" data-disable-with="検索" onClick={() => searchParts()}/>
                        </div>
                    </div>
                </div> 
            </div>
            <div className="row">
                <div className="col-sm-9"/>
                <div className="col-sm-2">
                    <a href="/institution_hearing_ids/edit" className="mb20 btn btn-primary">必須カテゴリ質問GooCo先確認ID設定</a>
                </div>
            </div>
            <div className="col-md-12 col-xs-12">
                <h3 className="red">管理者以外使用しないでください。<br/>アンケートを表示するには店舗毎にアンケート表示設定をしてください。<br/>※ 新規追加・変更・コピー・削除を行うと、全店舗に反映されます。</h3>
            </div>
            
            {/* 表示エリア */}
            <div className="table-responsive">
                <table id="notice_table" className="table table-bordered">
                    <thead>
                    <tr className="success">
                        <th scope="col" className="text-center col-md-3 col-sm-3 col-xs-3">質問名</th>
                        <th scope="col" className="text-center col-md-4 col-sm-4 col-xs-4">説明</th>
                        <th scope="col" className="text-center col-md-2 col-sm-2 col-xs-1">質問種類</th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                    </tr>
                    </thead>
                    <tbody>
                        { parts.map((part) =>
                            {   const is_owned = part.m_company_id === props.current_m_company_id
                                return(
                                    <>
                                        <tr>
                                            <td>{part.name}</td>
                                            <td>{part.description}</td>
                                            <td>{part.is_return_question ? "再来向け" : "新患／再来向け"}</td>
                                            <td className="text-center">
                                                <a className="btn btn-primary" onClick={() => showPreview(part.id)}>プレビュー</a>
                                                <input type="hidden" id="open_preview_modal" data-toggle="modal" data-target="#preview_modal"/>
                                            </td>                                            
                                            <td className="text-center">
                                                <button disabled={is_general_user} className="btn btn-primary" data-toggle="modal" data-target="#part_copy_modal" 
                                                    onClick={() => setCopyPart(part)}>コピー</button>
                                            </td>
                                            <td className="text-center">
                                                { is_owned && <button disabled={is_general_user} className="btn btn-primary" onClick={ ()=> location.href="/parts/edit?id=" + part.id}>編集</button> }
                                            </td>
                                            <td className="text-center">
                                                { is_owned && <button disabled={is_general_user} className="btn btn-danger" onClick={() => checkLinked(part)}>削除</button>}
                                                { is_owned && <input type="hidden" id="open_delete_modal" data-toggle="modal" data-target="#part_delete_modal"/>}
                                            </td>
                                        </tr>
                                    </>
                                )
                            }
                        )}
                    </tbody>
                </table>
            </div>

            <div className="actions mt40 text-center va_middle">
                <button disabled={is_general_user} className="btn btn-primary ml5" onClick={ ()=> location.href="/parts/new"}>質問登録</button>
            </div>
            {/* コピー確認モーダル */}
            <div className="modal fade" data-backdrop="static" id="part_copy_modal">
                <div className="sw-modal-content">
                <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
                    <div className="sw-modal-icon-question sw-modal-icon">?</div>
                    <h2>コピーします</h2>
                    <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                    以下のアンケート情報をコピーします。<br />
                    よろしいですか？<br />
                    【{copyPart && copyPart.name}】<br/>
                    </div>
                    <a type="button"
                        className="sw-modal-btn"
                        style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
                        data-dismiss="modal"
                        onClick={() => onClickCopyButton()}
                    >
                    コピーする
                    </a>
                    <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
                </div>
                </div>
            </div>

            {/* 削除確認モーダル */}
            <div className="modal fade" data-backdrop="static" id="part_delete_modal">
                <div className="sw-modal-content">
                <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
                    <div className="sw-modal-icon-question sw-modal-icon">?</div>
                    <h2>削除します</h2>
                    <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                    {isLinked && <><div className="red bold">質問情報に紐づくカテゴリが存在します。</div></>}
                    以下の質問情報を削除します。<br />
                    よろしいですか？<br />
                    【{deletePart && deletePart.name}】<br/>
                    </div>
                    <a type="button"
                        className="sw-modal-btn"
                        style={{ backgroundColor: 'red', textDecoration: 'none'}}
                        data-dismiss="modal"
                        onClick={() => onClickDeleteButton()}
                    >
                    削除する
                    </a>
                    <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
                </div>
                </div>
            </div>

            {/* プレビュー */}
            <ModalPreview part={previewPart} partFields={previewPartFields}/>
        </>
    )
}
export default Index;